import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[appMin]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }],
    standalone: false
})
export class MinValidatorDirective implements Validator {
  // Using the definite assignment operator since the value will be provided by the binding.
  @Input('appMin') min: number = .01;

  validate(control: AbstractControl): ValidationErrors | null {
    const valueStr = control.value;
    if (valueStr === null || valueStr === undefined || valueStr === '') {
      return null;
    }

    const value = parseFloat(valueStr);
    if (!isNaN(value) && value < this.min) {
      return { 'min': { value: control.value, min: this.min } };
    }
    return null;
  }
}
